import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography/Typography';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import IconButton from '@material-ui/core/IconButton';
import BackArrow from '@material-ui/icons/ArrowBackIos';
import LoadingIcon from '@material-ui/icons/Cached';
import AppBar from '@material-ui/core/AppBar/AppBar';
import Toolbar from '@material-ui/core/Toolbar/Toolbar';
import PropTypes from 'prop-types';

import styles from './PageStatus.style';
import './PageStatus.css';
import { db, getUser, redirectToRoot } from '../../utilities/firebase-config';
import { formatTimeStamp } from '../../utilities/utils';

function titleCase(stringToConvert) {
  if (!stringToConvert) {
    return null;
  }

  return stringToConvert.charAt(0).toUpperCase() + stringToConvert.substring(1);
}

function generateSummary(data) {
  if (!data) return null;

  return Object.keys(data).reduce((summary, e164) => {
    const newSummary = { ...summary };
    const status = (data[e164].twilioStatus || data[e164].status || '').toLowerCase();
    newSummary[status] = summary[status] + 1 || 1;
    return newSummary;
  }, {});
}

function Summary({ data }) {
  const keys = Object.keys(data).sort();

  return (
    <div>
      { keys.map(key => (
        <Typography variant="subtitle1" gutterBottom key={ key }>
          { titleCase(key) }
          &nbsp;:&nbsp;
          { data[key] }
        </Typography>
      ))}
    </div>
  );
}

Summary.propTypes = {
  data: PropTypes.object.isRequired,
};

class PageStatus extends Component {
  state = {
    loading: true,
    pageDetails: {},
    pageRequestsKey: null,
    summary: null,
  };

  async componentDidMount() {
    const user = await getUser();
    const { history } = this.props;

    if (!user) {
      redirectToRoot(history);
    }

    const pageRequestsKey = window.location.pathname.split('/')[2];

    if (pageRequestsKey) {
      this.setState({
        pageRequestsKey,
      });

      db.ref(`pageRequests/${pageRequestsKey}`).on('value', (snapshot) => {
        const data = snapshot.val();

        if (data) {
          const summary = generateSummary(data.status);

          // Let loading indicator display for a bit
          setTimeout(() => {
            this.setState({
              loading: false,
              pageDetails: data,
              summary,
            });
          }, 650);
        }
      });
    }
  }

  componentWillUnmount() {
    const { pageRequestsKey } = this.state;
    db.ref(`pageRequests/${pageRequestsKey}`).off();
  }

  goBack = () => {
    const { history } = this.props;
    history.goBack();
  };

  render() {
    const { classes } = this.props;
    const {
      loading,
      pageDetails,
      pageRequestsKey,
      summary,
    } = this.state;
    const status = pageDetails.status ? pageDetails.status : {};
    const { processInfo } = pageDetails;
    const keys = Object.keys(status);

    return (
      <div className="PageStatus container">

        <AppBar position="fixed" color="primary">
          <Toolbar>
            <IconButton className={ classes.menuButton } color="inherit" aria-label="Menu" onClick={ this.goBack }>
              <BackArrow />
            </IconButton>

            <Typography variant="h6" color="inherit">
              Page Status
            </Typography>
          </Toolbar>
        </AppBar>

        {
          pageRequestsKey
          && (
          <Typography variant="subtitle1" gutterBottom>
            Request ID :
            {' '}
            { pageRequestsKey }
          </Typography>
          )
        }

        {
          loading
          && <LoadingIcon className="loading-icon" />
        }

        {
          pageDetails.message
          && (
          <Typography variant="subtitle1" gutterBottom>
            Message :&nbsp;
            { pageDetails.message }
          </Typography>
          )
        }

        {
          processInfo && (
            <Typography variant="subtitle1" gutterBottom>
                Notify List Size :&nbsp;
                { processInfo.notifyListSize }
            </Typography>
          )
        }

        {
          processInfo && (
            <Typography variant="subtitle1" gutterBottom>
              Total Requested :&nbsp;
              { processInfo.totalSent }
            </Typography>
          )
        }

        {
          processInfo && (
            <Typography variant="subtitle1" gutterBottom>
              Skipped Due To Compliance :&nbsp;
              { processInfo.notSentDueToCompliance }
            </Typography>
          )
        }

        {
          summary && <Summary data={ summary } />
        }

        {
          !loading
          && (
          <Table className={ classes.table }>
            <TableHead>
              <TableRow>
                <TableCell className={ classes.cell }>Name</TableCell>
                <TableCell className={ classes.cell }>Phone</TableCell>
                <TableCell className={ classes.cell }>Status</TableCell>
                <TableCell className={ classes.cell }>Time</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {keys.map((key) => {
                const row = status[key];

                return (
                  <TableRow key={ key }>
                    <TableCell className={ classes.cell }>{row.name}</TableCell>
                    <TableCell className={ classes.cell }>{key}</TableCell>
                    <TableCell
                      className={ classes.cell }
                    >
                      {titleCase(row.twilioStatus || row.status)}
                    </TableCell>
                    <TableCell
                      className={ classes.cell }
                    >
                      {formatTimeStamp(row.updatedTs || row.ts)}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          )
        }

      </div>
    );
  }
}

PageStatus.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default withStyles(styles)(PageStatus);
